exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".AuthorizePage{position:fixed;top:0;left:0;right:0;bottom:0;background-color:rgba(255,255,255,.5);z-index:2;display:flex;justify-content:center;align-items:center}", ""]);

// exports
